<h1 mat-dialog-title>Error</h1>
<div mat-dialog-content>
    <div style="margin-bottom: 20px;">
        {{message}}
    </div>
</div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close color="accent">Close</button>
</div>